import React from 'react';
import './ticketnumb.css'
import pic28 from'../../assets/pic28.png'
import pic29 from'../../assets/pic29.png'


const Ticketnum = ({ title, value, onChange }) => {


    const decreaseTickets = () => {
    if (value > 1) {
        onChange(value - 1);
    }

};

const increaseTickets = () => {
     onChange(value + 1);
};



    return ( 
        <fieldset className='container-input'>
            <label className='title-inputt'>{title}</label>
            <fieldset className='container-row-input-ticket-numb'>
                <button className='addcta' onClick={decreaseTickets} type="button">
                    <img className='icon-ctaa-plus' src={pic28} alt='minus'></img>
                </button>
                
                <h2 className='input-numberrr-ticket-number'>
                      {value}
                </h2>

                <button className='addcta' onClick={increaseTickets} type="button" >
                    <img className='icon-ctaa-plus' src={pic29} alt='plus'></img>
                </button>


            </fieldset>
        </fieldset>
     );
}
 
export default Ticketnum;